import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';
import Api from '../services';

interface TamaraOptions {
  description: string;
  name: string;
}

const usePaymentMethods = () => {
  const [paymentMethods, setPaymentMethods] = useState<any[]>([]);
  const [tamaraOptions, setTamaraOptions] = useState<TamaraOptions[]>([]);
  const [loadingCards, setLoadingCards] = useState(true);
  const [loadingTapConfig, setLoadingTapConfig] = useState(true);
  const [loadingTamara, setLoadingTamara] = useState(true);
  const [tapUserDetails, setTapUserDetails] = useState<any>(null);
  const [tapPublicKey, setTapPublicKey] = useState<string | null>(null);
  const total = useSelector((state: RootState) => state.cart.total);

  const fetchPaymentMethods = async () => {
    setLoadingCards(true);
    try {
      const response = await Api.paymentMethods.getCards();
      setPaymentMethods(response.data || []);
    } catch {
      console.error('Failed to fetch saved cards');
      setPaymentMethods([]);
    } finally {
      setLoadingCards(false);
    }
  };

  const deletePaymentMethod = async (paymentMethodId: string) => {
    try {
      await Api.paymentMethods.deleteCard(paymentMethodId);
      setPaymentMethods((prevMethods) => prevMethods.filter((method) => method.id !== paymentMethodId));
    } catch {
      console.error('Failed to delete payment method');
    }
  };

  const fetchTapConfigs = async () => {
    try {
      const userDetails = await Api.tap.getTapUser();
      setTapUserDetails({
        id: userDetails.data?.attributes?.tap_customer_id,
        first_name: userDetails.data?.attributes?.full_name,
        email: userDetails.data?.attributes?.tap_email,
        phone: {
          country_code: userDetails.data?.attributes?.payment_mobile.country_code,
          number: userDetails.data?.attributes?.payment_mobile.number,
        },
      });

      const tapConfig = await Api.tap.getTapSdkKey();
      setTapPublicKey(tapConfig?.publicKey);
    } catch (err) {
      console.error('Failed to load Tap configurations', err);
    } finally {
      setLoadingTapConfig(false);
    }
  };

  const fetchTamaraOptions = async (amount?: number) => {
    setLoadingTamara(true);
    try {
      const response = await Api.paymentMethods.getTamaraOptions(amount ?? total);
      setTamaraOptions(response || []);
    } catch (err) {
      console.error('Failed to fetch Tamara options', err);
      setTamaraOptions([]);
    } finally {
      setLoadingTamara(false);
    }
  };

  useEffect(() => {
    fetchTamaraOptions();
  }, []);

  return {
    fetchPaymentMethods, fetchTamaraOptions, tamaraOptions, loadingCards, loadingTapConfig, loadingTamara, paymentMethods, fetchTapConfigs, tapPublicKey, tapUserDetails, deletePaymentMethod,
  };
};

export default usePaymentMethods;
